const ru = {
  translation: {
    //home
    home: "Главная",
    vehicles: "Автомобили",
    sign_in: "Войти",
    plan_you_trip: "Запланируйте свою поездку сейчас",
    save_big: "Экономьте с нашей доступной арендой автомобилей!",
    with_our_car: "с нашей доступной арендой автомобиля!",
    save_big_desc:
      "Арендуйте автомобиль своей мечты. Непобедимые цены, неограниченное количество миль, гибкие варианты получения и многое другое.",
    book_ride: "Заказать поездку",
    learn_more: "Узнать больше",
    book_a_car: "Забронировать автомобиль",
    without_driver: "Без водителя",
    with_driver: "С водителем",
    select_booking_type: "Выберите тип бронирования",
    self_drive: "Самостоятельное управление",
    tour: "Тур / Ежедневная аренда",
    transfer_service: "Трансфер",
    pickup_date: "Дата получения",
    dropoff_date: "Дата возврата",
    pickup_location: "Место получения",
    dropoff_location: "Место возврата",
    book_now: "Забронировать сейчас",
    the_price_exclude: "Цена не включает в себя плату за водителя, которая будет дополнительной платой",
    select_tour_package: "Выберите тур-пакет",
    select_duration: "Выберите продолжительность",
    destination_location: "Место назначения",
    quick_and_easy: "Быстрая и простая аренда автомобиля",
    select_car: "Выберите автомобиль",
    we_offer:
      "Мы предлагаем большой выбор автомобилей для всех ваших водительских потребностей. У нас есть идеальный автомобиль, чтобы удовлетворить ваши потребности",
    contact_operator: "Связаться с оператором",
    our_knowlage: "Наши компетентные и дружелюбные операторы всегда готовы помочь с любыми вопросами или заботами",
    let_drive: "Поехали в путь",
    whether_you: "Будь то дороги, у нас есть вас покрыты с нашим широким ассортиментом автомобилей",
    vehicle_models: "Модели автомобилей",
    our_rental_fleet: "Наш парк арендных автомобилей",
    choose_from:
      "Выбирайте из разнообразия наших удивительных автомобилей для аренды на вашем следующем приключении или деловой поездке",
    reserve_now: "ЗАБРОНИРОВАТЬ СЕЙЧАС",
    save_big_bottom: "Экономьте крупные суммы с нашей дешевой арендой автомобилей!",
    top_airport: "Лучшие аэропорты. Местные поставщики. ",
    support: "поддержка",
    why_choose_use: "Почему выбрать нас",
    best_valued: "Лучшие предложения, которые вы когда-либо найдете",
    discover_the_best:
      "Откройте для себя лучшие предложения, которые вы когда-либо найдете с нашими непобедимыми предложениями. Мы стремимся предоставить вам лучшую ценность за ваши деньги, чтобы вы могли наслаждаться услугами и продуктами высокого качества, не разорившись. Наши предложения разработаны, чтобы предоставить вам максимальный опыт аренды, так что не упустите шанс сэкономить крупные суммы.",
    find_details: "Найти детали",
    cross_city: "Перекрестный городской драйв",
    take_your_driving:
      "Поднимите ваш опыт вождения на новый уровень с нашими автомобилями высшего класса для ваших кросс-кантри приключений.",
    all_inclusive: "Все включено",
    get_everything: "Получите все, что вам нужно, в одной удобной и прозрачной цене с нашей политикой все включено.",
    no_hidden: "Нет скрытых сборов",
    enjoy_peace:
      "Наслаждайтесь покоем души с нашей политикой без скрытых сборов. Мы верим в прозрачную и честную ценовую политику.",
    review_by_people: "Отзывы людей",
    client_testimonial: "Отзывы клиентов",
    client_testimonial_desc:
      "Узнайте о положительном влиянии, которое мы оказали на наших клиентов, прочитав их отзывы. Наши клиенты испытали наш сервис и результаты, и они готовы поделиться своими положительными впечатлениями с вами.",
    testi_aris:
      "Мне действительно нравится. Сервис такой же крутой, как водитель приходит вовремя и знает путь. Очень доволен, сервис действительно здорово. И машина тоже. Пахнет чисто, и все идет гладко. Делайте Мас Йойок (водителя) успешным и здоровым, и да... Для предпринимателя по аренде автомобилей я ничего не хочу говорить. Потому что не было жалоб. В общем, удачи.",
    testi_solomon:
      "Я арендовал Avanza, тип G, 2016 года. У машины не было проблем, двигатель работал плавно, кузов был аккуратно зарегистрирован, а самое главное, когда вы арендуете машину, команда/группа WA сразу готова... для запрашиваемых документов... это круто. главное это.",
    faq: "Часто задаваемые вопросы",
    frequently_asked: "Часто задаваемые вопросы",
    frequently_asked_desc:
      "Часто задаваемые вопросы о процессе бронирования автомобиля на нашем веб-сайте: ответы на общие вопросы и запросы.",
    what_is_special: "1. Чем особенно сравнение предложений по аренде автомобилей?",
    what_is_special_desc:
      "Сравнение предложений по аренде автомобилей важно, так как оно помогает найти лучшее предложение, соответствующее вашему бюджету и потребностям, обеспечивая наибольшую ценность за ваши деньги. Сравнив различные варианты, вы можете найти сделки, предлагающие более низкие цены, дополнительные услуги или лучшие модели автомобилей. Вы можете найти предложения по аренде автомобилей, исследуя их онлайн и сравнивая цены от разных арендных компаний.",
    how_do_2: "2. Как найти предложения по аренде автомобилей?",
    how_do_2_desc:
      "Вы можете найти предложения по аренде автомобилей, исследуя их онлайн и сравнивая цены от разных арендных компаний. Веб-сайты, такие как Expedia, Kayak и Travelocity, позволяют сравнивать цены и просматривать доступные варианты аренды. Также рекомендуется подписаться на рассылки по электронной почте и следить за арендными компаниями по социальным сетям, чтобы быть в курсе каких-либо специальных предложений или акций.",
    how_do_3: "3. Как найти такие низкие цены на аренду автомобилей?",
    how_do_3_desc:
      "Бронирование заранее: Забронировать аренду автомобиля заранее часто позволяет получить более низкие цены. Сравнивайте цены у нескольких компаний: Используйте веб-сайты, такие как Kayak, Expedia или Travelocity, для сравнения цен у нескольких арендных компаний. Ищите скидочные коды и купоны: Ищите скидочные коды и купоны, которые вы можете использовать для снижения стоимости аренды. Иногда аренда из места вне аэропорта может привести к более низким ценам.",
    reservation_12: "Бронирование должно быть сделано как минимум за 12 часов до",
    reservation_24: "Бронирование должно быть сделано как минимум за 24 часа до",
    drop_after_pickup: "Дата сдачи должна быть после даты получения",
    //car card
    daily_rate_from: "Дневная ставка от",
    includes: "Включает",
    isurances_etc: "СТРАХОВАНИЕ, ОБСЛУЖИВАНИЕ КЛИЕНТОВ",
    more_info: "Дополнительная информация",
    efficient: "Эффективно",
    safe: "Безопасно",
    economical: "Экономичный",
    //select vehicle
    book_car_by_getting: "Забронируйте автомобиль, связавшись с нами",
    select_vehicle: "Выбрать транспортное средство",
    complete_reservation: "ЗАВЕРШИТЕ БРОНИРОВАНИЕ",
    upon_completing: "Завершив этот запрос на бронирование, вы получите:",
    your_rent_voucher:
      "Ваш ваучер на аренду, который необходимо предъявить при прибытии на стойке аренды, и бесплатный номер службы поддержки клиентов.",
    location_n_date: "Место и Дата",
    car: "Автомобиль",
    pickup_date_n_time: "Дата и Время Подачи",
    dropoff_date_n_time: "Дата и Время Возврата",
    prices: "Цены",
    additional_items: "Дополнительные Пункты",
    umbrella: "Зонтик",
    baby_seat: "Детское Кресло",
    insurance: "Страхование",
    full_covered: "Полное Страхование",
    wedding: "Свадебный автомобиль",
    flower_arrangement: "Цветочное оформление (Свадебный автомобиль)",
    additional_stop: "Дополнительная остановка",
    flower_bouquet: "Цветочный букет",
    all_in_one_for: "Плата за проезд и стоянка",
    price_estimate: "Смета Стоимости",
    estimate_total: "Итоговая Смета",
    the_price_does_not: "Цена не включает плату за проезд, стоянку и чаевые",
    the_price_includes: "Цена включает в себя бензин и плату за парковку в одну сторону.",
    personal_info: "ЛИЧНАЯ ИНФОРМАЦИЯ",
    identity_type: "Тип Удостоверения личности",
    select_identity: "Выберите Удостоверение личности",
    identity_image: "Изображение Удостоверения личности",
    choose_file: "Выберите файл",
    sim_or: "Водительское Удостоверение / Права",
    name: "Имя",
    booker_name: "Имя бронирующего",
    enter_booker_name: "введите_имя_бронирующего : результат_перевода",
    enter_name: "Введите ваше имя",
    whatsapp_number: "Номер WhatsApp",
    enter_whatsapp_number: "Введите ваш номер WhatsApp",
    email: "Email",
    enter_email: "Введите ваш адрес электронной почты",
    address: "Адрес",
    enter_address: "Введите ваш адрес",
    emergency_contact_1: "Контакт Чрезвычайной помощи 1",
    emergency_contact_2: "Контакт Чрезвычайной помощи 2",
    enter_emergency: "Введите контакт в случае чрезвычайной ситуации",
    return_flight: "Бронирование Обратного Рейса",
    hotel_accomodation: "Отель/Проживание во время вашего пребывания",
    notes: "Заметки",
    enter_notes: "Введите ваши заметки",
    we_will_ask: "Мы запросим дополнительные данные, если это потребуется.",
    rental_policy: "Политика Аренды",
    in_town_usage: "Использование в городе",
    add_outside_island: "Добавить использование вне острова",
    outside_island_usage: "Использование вне острова",
    for_self_drive: "Использование вне острова для самостоятельного вождения",
    denpasar_jimbaran_etc: "Денпасар, Джимбаран, Легиан, Нуса Дуа, Улувату, Центр Убуда, Семиньяк.",
    out_of_town_usage: "Использование вне города",
    zone_1: "Зона 1",
    zone_2: "Зона 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (fee depends on car type)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (fee depends on car type)",
    this_rate_valid: "Данная ставка действительна только в одну сторону.",
    add_out_off_town: "ДОБАВИТЬ ИСПОЛЬЗОВАНИЕ ВНЕ ГОРОДА",
    select_date: "Выберите Дату",
    select_travel_date: "Выберите дату поездки за пределами города",
    select_travel_date_island: "Выберите дату поездки вне острова",
    total: "Итого",
    close: "Закрыть",
    add: "Добавить",
    loading: "Загрузка...",
    //customer form
    additional_information: "Дополнительная информация (по желанию)",
    guest_name: "Имя гостя",
    driver_name: "Имя водителя",
    passanger_total: "Общее количество пассажиров",
    luggage_total: "Общее количество багажа",
    flight_detail: "Детали рейса",
    airline_name: "Пример: название авиакомпании: Гаруда, время прибытия: 17:00",
    hotel_detail: "Детали отеля/жилья",
    hotel_name: "Пример: название отеля: Индах Отель",
    disability_needs: "Потребности по инвалидности",
    wheelchair: "Пример: количество инвалидных колясок: 1",
    the_price_varies: "Цена зависит от места назначения.",
    including_petrol: "Включая проезд и парковку",
    change: "Изменить",
    setting_date_use: "Настройка даты использования",
    date: "дата",
    //detail vehicle
    detail_vehicle: "Подробности автомобиля",
    price_type: "Тип цены",
    price: "Цена",
    area: "Площадь",
    yes: "Да",
    trunk: "Багажник",
    customer_service: "СЛУЖБА ПОДДЕРЖКИ",
    insurances: "СТРАХОВКА",
    with_a_professional:
      "Благодаря профессиональному и обширному сервису после продажи вы можете спать спокойно благодаря хорошей поддержке нашей команды. Вы также можете воспользоваться различными привлекательными предложениями и специальными акциями при заказе этой машины.",
    select_this_car: "Выбрать этот автомобиль",
    //global
    save: "Сохранить",
    big: "большие",
    days: "Дни",
    hour: "Час",
    brand: "Бренд",
    year: "Год",
    seat: "Место",
    ac: "Кондиционер",
    color: "Цвет",
    transmission: "Трансмиссия",
    fuel: "Топливо",
    company: "Компания",
    working_hour: "Часы работы",

    //privacy and policy
    privacy_and_police: "Условия и положения",
    for_overtime:
      "За переработку взимается дополнительная плата в размере 50 000 Rp / час (Переработка более 2 часов засчитывается как 1 день использования).",
    for_extension:
      "Для продления аренды единицы более 2 раз, пожалуйста, подтвердите это в нашем офисе Wirasana Rent A Car Denpasar, Jl. Bypass Ngurah Rai No.162, Sanur Kaja, South Denpasar.",
    unit_vehicles:
      "Аренда автомобилей не может быть передана/использована кем-либо, кроме арендатора, который подписал договор аренды (если автомобиль используется в качестве доказательства, будет взиматься плата за аренду за день).",
    reschedule_or:
      "Перепланировка или изменение места получения/сдачи единицы не может быть подтверждена, если уведомление составляет менее 1x24 часа в соответствии с графиком бронирования, чтобы избежать ошибок в настройках операций.",
    reschedule_date:
      "За перепланировку даты или времени получения/сдачи единицы взимается плата в размере 75 000 Rp (максимум 2 перепланировки разрешено).",
    for_lose_umbrella: "За утерю зонта во время аренды взимается плата в размере 100 000 Rp за зонт.",
    for_lose_baby_seat:
      "За утерю детского автокресла во время аренды взимается плата в размере 2 000 000 Rp за детское автокресло.",
    usage_unit: "Использование единицы разрешено только в районе Бали.",
    lose_stnk: "За утерю STNK (регистрации автомобиля) взимается плата в размере 1 500 000 Rp.",
    lose_plat: "За утерю номерных знаков взимается плата в размере 250 000 Rp.",
    for_damage_ban:
      "За повреждение шин из-за неправильной эксплуатации/использования не асфальтированных дорог взимается плата в размере 700 000 Rp за шину.",
    for_beret: "Если есть новые царапины, взимается плата в размере 750 000 Rp за каждое происшествие.",
    towing_fee: "Плата за буксировку автомобиля и аренду автомобиля во время ремонта не включена в собственные риски.",
    lack_of_petrol:
      "Недостаток топлива во время получения или сдачи в аренду будет облагаться платой 100 000 Rp за коробку.",
    fuel_in_the_middle:
      "Если во время поездки заканчивается топливо посреди пути, будет взиматься плата за обработку 250 000 Rp за районы в пределах города.",
    smell:
      "Если при возврате автомобиля есть запах дуриана/рвоты/сигарет/мокрых автокресел, будет взиматься плата 1 500 000 Rp.",
    dirty_car: "За возвращение автомобиля в очень грязном состоянии взимается плата 150 000 Rp.",
    lost_the_key: "За утерю ключей от автомобиля будет взиматься плата 1 500 000 Rp.",
    more_than_one_driver: "Если есть более одного водителя, будет взиматься плата 50 000 Rp/ID/день.",
    please_not_park:
      "Пожалуйста, не паркуйте автомобиль под деревьями или в местах, которые могут создать опасность для положения автомобиля.",
    charging_error: "В случае ошибки заправки топлива будет взиматься плата за ремонт в размере 2 500 000 Rp.",
    not_info:
      "Если мы не получим информацию, касающуюся необходимости помощи в ремонте автомобиля во время аренды, мы не примем возмещение из любой мастерской без согласования/обсуждения.",
    trouble_car:
      "Если возникнут проблемы с автомобилем, наши механики постараются связаться и помочь вам в течение максимум 4 часов (в зависимости от вашего местоположения в это время).",
    security_deposit:
      "Залоговый депозит в размере 500 000 Rp будет удерживаться в качестве гарантии на всем протяжении срока аренды (залог будет возвращен через банковский перевод в течение максимум 7 дней после возврата автомобиля и после проверки E-Tilang).",
    basic_usage: "Базовое использование ограничено городом согласно карте Traveloka.",
    excess_usage:
      "Использование более 12 часов или после полуночи будет облагаться дополнительной платой согласно приложению/правилам Traveloka.",
    driver_contact: "Водитель свяжется с вами, когда он приблизится к месту посадки.",
    other_questions: "Если у вас есть еще вопросы, не стесняйтесь связаться с нами.",
    pickup_point:
      "Пункт подачи находится перед Solaria, если вы хотите запросить другой пункт подачи, пожалуйста, сообщите нам непосредственно через эту группу.",
    reschedule_info:
      "Перенос или изменение пункта подачи и места назначения не могут быть подтверждены, если уведомление поступило менее чем за 24 часа до запланированной брони, чтобы избежать ошибок в организации операций.",
    reschedule_fee: "Действует плата за перенос в размере 75 000 рупий (максимум 2 переноса).",
    reschedule_airline:
      "При переносах, связанных с изменением авиакомпании, прикрепите подтверждение переноса, и мы подтвердим его без дополнительной платы за перенос. Однако тип транспортного средства для подачи будет зависеть от его доступности на новое время подачи.",
    airline_delay:
      "В случае задержки рейса, предоставьте подтверждение задержки. Наш водитель сделает все возможное, чтобы подобрать вас в соответствии с последним графиком.",
    voucher_usage: "Ваучер действителен для однократной подачи без остановок или однонаправленной поездки.",
    additional_stop_meals:
      "Дополнительные остановки для еды и т. д. облагаются дополнительной платой в размере 100 000 рупий в час.",
    driver_wait_time:
      "Водитель будет ждать вас до 30 минут. Если задержка превысит указанное время, будет взиматься дополнительная плата в размере 100 000 рупий в час.",
    destination_change:
      "За изменение места назначения будет взиматься дополнительная плата в зависимости от местоположения.",
    no_eating_drinking:
      "Запрещается употребление пищи и напитков, которые могут вызвать разливы внутри транспортного средства.",
    boarding_landing: "Пожалуйста, подтвердите, когда вы сели на борт и приземлились в аэропорту Нгура Рай.",
    driver_details: "Сведения о водителе будут предоставлены в день поездки.",
    mask_and_distance:
      "Пожалуйста, всегда носите маску и соблюдайте социальное расстояние внутри транспортного средства.",
    disinfected_vehicles: "Все транспортные средства Wirasana были дезинфицированы заранее.",
    SWAB_driver_charge: "Дополнительная плата за тест SWAB водителя составляет 99 000 рупий (по необходимости).",
    passenger: "Пассажир",
    use_the_current_location: "Использовать текущее местоположение",
    cancel: "Отмена",
    confirm: "Подтвердить",
    i_have_read_and_accept: "Я прочитал и принимаю политику конфиденциальности",
    i_accept_the_privacy: "Я принимаю политику конфиденциальности",
    open_filters: "Открыть фильтры",
    sort: "Сортировать",
    price_low_to_high: "Цена: по возрастанию",
    price_high_to_low: "Цена: по убыванию",
    name_a_z: "Имя: A → Z",
    name_z_a: "Имя: Z → A",
    filters: "Фильтры",
    price_per_day: "Цена за день",
    total_passenger: "Всего пассажиров",
    drivetrain: "Привод",
    clear_all: "Очистить все",
    apply_filters: "Применить фильтры",
    search_car: "Поиск автомобиля",
    ready_to_continue_payment: "Готовы продолжить оплату?",
    please_review_payment: "Пожалуйста, проверьте данные оплаты перед продолжением.",
    total_amount: "Общая сумма к оплате",
    proceed_to_payment: "Перейти к оплате",
    about: "О нас",
    about_company: "О компании",
    about_headline: "Запустите двигатель, и ваше приключение начнется",
    about_description:
      "Просто, но с полной отдачей, мы стремимся предоставить лучший сервис, чтобы каждая поездка была комфортной, безопасной и запоминающейся.",
    about_car_types: "Типы автомобилей",
    about_rental_outlets: "Пункты аренды",
    about_repair_shop: "Сервисные центры",
    about_book_car: "Забронируйте автомобиль, связавшись с нами",
    about_phone: "(0361) 286-066",
    language: "Язык",
    about_us: "О нас",
    contact_us: "Связаться с нами",
    booking_type: "Тип бронирования",
    the_royal_essence: "Королевская сущность путешествия",
    relaxed_journey: "САМОЕ РАССЛАБЛЯЮЩЕЕ ПУТЕШЕСТВИЕ",
    page_title: "Контакт",
    headline: "Нужна дополнительная информация?",
    description:
      "Многофункциональный профессионал с более чем 15-летним опытом в области исследований, разработок и обучения.",
    phone_label: "Телефон",
    email_label: "Эл. почта",
    address_label: "Адрес",
    form_name: "Полное имя",
    form_message: "Расскажите нам об этом",
    form_placeholder_name: "Напр.: 'Иван Иванов'",
    form_placeholder_message: "Напишите здесь...",
    form_button: "Отправить через WhatsApp",
    required_alert: "Пожалуйста, заполните все обязательные поля!",
    address_value: "Денпасар, Бали",
    why_choose_wirasana: "Почему выбирают Wirasana",
    trusted_partner: "Ваш надежный партнер по аренде автомобилей на Бали",
    experience_excellence: "Оцените превосходство наших автомобилей, сервиса и прозрачных цен.",
    happy_customers: "Довольные клиенты",
    vehicles_available: "Доступные автомобили",
    years_experience: "Лет опыта",
    satisfaction_rate: "Уровень удовлетворенности",
    what_makes_us_different: "Что делает нас особенными",
    discover_advantages: "Узнайте, чем мы отличаемся от конкурентов",
    comprehensive_insurance: "Полное страхование",
    comprehensive_insurance_desc: "Полное страховое покрытие включено в каждую аренду.",
    premium_fleet: "Премиум автопарк",
    premium_fleet_desc: "Современные автомобили в идеальном состоянии для комфортной поездки.",
    support_247: "Поддержка 24/7",
    support_247_desc: "Круглосуточная служба поддержки клиентов.",
    best_price: "Гарантия лучшей цены",
    best_price_desc: "Прозрачные тарифы, никаких скрытых платежей.",
    flexible_rental: "Гибкая аренда",
    flexible_rental_desc: "Выбирайте удобный срок аренды — от часа до месяца.",
    free_delivery: "Бесплатная доставка",
    free_delivery_desc: "Бесплатная доставка и возврат автомобиля по вашему адресу на Бали.",
    more_reasons: "Больше причин доверять нам",
    trusted_by_thousands: "Нам доверяют тысячи клиентов",
    trusted_by_thousands_desc: "Более 10 000 довольных клиентов выбрали нас на Бали.",
    licensed_insured: "Лицензировано и застраховано",
    licensed_insured_desc: "Наш автопарк полностью лицензирован и застрахован.",
    easy_booking: "Простое бронирование",
    easy_booking_desc: "Забронируйте онлайн за несколько минут без лишней бумажной волокиты.",
    flexible_payment: "Гибкие способы оплаты",
    flexible_payment_desc: "Принимаем карты, переводы и электронные кошельки.",
    cta_title: "Готовы начать свое путешествие?",
    cta_desc: "Забронируйте идеальный автомобиль уже сегодня и почувствуйте разницу с Wirasana.",
    call_us_now: "Позвонить сейчас",
    back: "Назад",
    weather_protection: "Защита от непогоды для активного отдыха на открытом воздухе",
    safety_seat_children: "Детское сиденье безопасности (5–4 лет)",
    beautiful_flower_arrangements: "Красивые цветочные композиции для особых случаев",
    extra_stops: "Дополнительные остановки во время поездки",
    all_in_one_package: "Удобный пакет «всё в одном»",
    fresh_flower_bouquet: "Аранжировка из свежих цветов",
    set_quantity_each_date: "Установить количество для каждой даты",
    total_items: "Всего предметов",
    items: "Предметы",
    select_all: "Выбрать всё",
    select_dates_apply_item: "Выберите даты, для которых хотите применить этот элемент",
    item_will_be_applied: "Элемент будет применён",
    out_of: "из",
    total_day: "всего дней",
    type_or_choose_location: "Введите местоположение или выберите из списка...",
    select_from_map: "Выбрать местоположение на карте",
    popular_locations: "Популярные места",
    manual_input_hint: "Или введите местоположение вручную в поле поиска",
    common: {
      back: "Назад",
      back_to_search: "Вернуться к поиску",
      name: "Имя",
      email: "Электронная почта",
      phone: "Телефон",
      total: "Общий",
      hours: "Часы",
      processing: "Обработка...",
      searching: "Идет поиск...",
      error_occurred: "Произошла ошибка. ",
      information: "Информация",
    },
    booking: {
      detail: "Детали бронирования",
      booking_number: "Номер бронирования{{number}}",
      not_found: "Данные не найдены",
      search_again: "Пожалуйста, найдите свое бронирование еще раз.",
      type: "Тип бронирования",
      pickup_date: "Дата получения",
      dropoff_date: "Дата возврата",
      price_breakdown: "Распределение цен",
      price_date: "Цена ({{date}})",
      fees: "Комиссии за транзакции и налоги",
      delivery_fee: "Стоимость доставки",
      pickup_fee: "Плата за самовывоз",
      canceled: "Заказ отменен",
      contact_customer_service: "Этот заказ был отменен. ",
      check_history: "Проверить историю бронирований",
      enter_details: "Введите свой адрес электронной почты и код бронирования, чтобы просмотреть детали вашего заказа.",
      booking_code: "Код бронирования",
      code_example: "Пример: S-0018, T-0025 (используйте S-0018 для демонстрации)",
      check_booking: "ПРОВЕРИТЬ БРОНИРОВАНИЕ",
      info_code_sent: "Код бронирования будет отправлен на вашу электронную почту после бронирования.",
      info_continue_payment: "Вы можете продолжить оплату неоплаченных заказов",
      info_contact_support: "Если у вас возникли проблемы, обратитесь в службу поддержки клиентов",
    },
    status: {
      booked: "Забронировано",
      prepared: "Готовый",
      operated: "Управляемый",
      canceled: "Отменено",
      success: "Успех",
    },
    payment: {
      not_paid: "Не оплачено",
      paid: "Оплаченный",
      partial: "Частичная оплата",
      continue: "ПРОДОЛЖИТЬ ОПЛАТУ",
      invoice_not_found: "Счет не найден",
      link_failed: "Не удалось создать ссылку для оплаты. ",
      received: "Платеж получен",
      total_paid: "Всего оплачено: {{amount}}",
    },
    validation: {
      fill_all_fields: "Пожалуйста, заполните адрес электронной почты и код бронирования.",
    },
    manage_booking: "Управление бронированием",
    booking_confirmation: "Подтверждение бронирования",
    next: "Следующий",
    booking_details: "Детали бронирования",
    review_n_confirm: "Обзор и подтверждение",
    booking_success: "Бронирование успешно!",
    booking_success_message: "Ваше бронирование успешно отправлено. ",
    open_payment_link: "Открыть ссылку для оплаты",
    required_documents: "Необходимые документы",
    payment_information: "Информация об оплате",
    review_payment_details: "Пожалуйста, проверьте свои платежные данные и перейдите к оплате.",
    booking_summary: "Сводка бронирования",
    invoice_number: "Номер счета",
    customer_name: "Имя клиента",
    payment_instructions: "Платежные инструкции",
    payment_instruction_1: "Нажмите кнопку ниже, чтобы создать счет на оплату",
    payment_instruction_2: "Вы будете перенаправлены на страницу оплаты Xendit.",
    payment_instruction_3: "Завершите оплату, используя доступные способы оплаты.",
    payment_instruction_4: "Вы получите подтверждение по электронной почте после успешной оплаты",
    payment_link_created: "Ссылка на оплату создана!",
    click_below_to_proceed: "Нажмите кнопку ниже, чтобы перейти к оплате",
    creating_invoice: "Создание счета...",
    create_payment_invoice: "Создать счет на оплату",
    done: "Я завершил платеж",
    order_summary: "Сводка заказа",
    please_review_order: "Пожалуйста, проверьте данные вашего заказа перед оплатой",
    customer_information: "Информация о клиенте",
    phone: "Телефон",
    vehicle: "Транспортное средство",
    rental_period: "Период аренды",
    locations: "Локации",
    price_breakdown: "Разбивка стоимости",
    base_price: "Базовая цена",
    delivery_fee: "Стоимость доставки",
    pickup_fee: "Стоимость забора",
    tour_package: "Цены на туристические пакеты начинаются от",
    airport_transfer_from: "Цены на трансфер из аэропорта начинаются от",
    tourPackage: "Туристический Пакет",
    basic_title: "Базовая защита",
    basic_subtitle: "Базовое покрытие включено в стоимость аренды",
    km_unlimited: "Неограниченный пробег",
    own_risk: "С платой за собственный риск в размере 750 000 рупий за инцидент.",
    damage_cover: "Страхование от столкновений, царапин и ударов",
    glass_tire: "Защита шин и стекол",
    interior_protect: "Внутренняя защита",
    not_included_towing: "Не включает услуги эвакуатора и дополнительные дни аренды, если ремонт длится более 7 дней.",
    got_it: "Понятно",
    basic_protection: "Базовая защита",
    see_more_details: "Посмотреть более подробную информацию",
    gps: "GPS",
    gps_desc: "Навигационная система в автомобиле.",
    phone_holder: "Держатель телефона",
    phone_holder_desc: "Крепление для безопасного вождения без рук.",
    family_card: "Семейная карта",
    business_id: "Идентификатор бизнеса",
    social_media: "Социальные сети",
    customer_info: "Информация о клиенте",
    enter_social_media: "Введите соцсети",
    insurance_subtitle: "Защитите свое путешествие с помощью комплексного покрытия и душевного спокойствия.",
    included: "Включено",
    not_included: "Не включено",
    toll_and_parking: "Платные дороги и парковка",
    toll_and_parking_desc: "Плата за дороги и парковку",
    your_trusted_mobility: "Ваш надежный партнер по мобильности на Бали",
    wirasana_is_professional:
      "Wirasana Rent A Car — это профессиональная служба проката автомобилей, базирующаяся на Бали, стремящаяся предоставлять надежные, комфортные и гибкие транспортные решения для путешественников и бизнеса. Имея многолетний опыт в транспортной отрасли, мы понимаем, что мобильность является неотъемлемой частью каждого путешествия — будь то отдых, работа или особые мероприятия.",
    our_mission_is_to_make:
      "Наша миссия — сделать транспорт на Бали простым, безопасным и доступным. Мы предлагаем широкий выбор хорошо обслуживаемых автомобилей для удовлетворения различных потребностей: от компактных автомобилей для личных поездок до автомобилей премиум-класса для деловых и особых мероприятий.",
    lets_get_you: "Давайте отправим вас в путь",
    have_questions_about:
      "Есть вопросы о наших автомобилях, ценах или наличии? Наша команда готова помочь вам. Планируете ли вы отпуск на Бали, деловую поездку или особое мероприятие, мы здесь, чтобы сделать ваш транспортный опыт гладким и беззаботным.",
    search_vehicle: "Поиск транспортного средства",
    vehicle_type: "Тип транспортного средства",
    motorcycle: "Мотоцикл",
    all: "Все",
    your_trustedcar_rental_in_bali: "Надежный прокат автомобилей на Бали",
    simple_booking: "Простое бронирование. Надежные автомобили. Исключительный сервис.",
    we_provide_flexible:
      "Мы предлагаем гибкие решения аренды, включая прокат без водителя, услуги водителя и трансферы из аэропорта, которые сделают ваше путешествие по Бали легким и приятным.",
  },
};

export default ru;
